import React from 'react';
import { useScript } from '@benzinga/hooks';

export const Simlink: React.FC = () => {
  useScript('https://s.skimresources.com/js/152346X1618118.skimlinks.js', 'body');

  return null;
};
